import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'primereact/button';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import LmsNewsTable from './components/LmsNewsTable';
import LmsNewsFormDialog from './components/LmsNewsFormDialog';
import useLmsNewsManagementData from './hooks/useLmsNewsManagementData';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { isAnnouncement } from '../utils/newsUtils';
import { useLmsPermission } from '../../hooks/useLmsPermission';
import { LMS } from '../../../../constants/permissionCodes';

const LmsNewsManagementPage = () => {
    const { th } = useLanguage();
    const { can } = useLmsPermission();
    const { items, totalCount, loading, lazyParams, onPage, sortField, sortOrder, onSort, filters, onFilter, clearFilters, deleteNews, refetch } = useLmsNewsManagementData();
    const [formVisible, setFormVisible] = useState(false);
    const [editingId, setEditingId] = useState(null);

    const openForm = useCallback((id = null) => {
        setEditingId(id);
        setFormVisible(true);
    }, []);

    const handleEdit = useCallback((row) => openForm(row.id), [openForm]);

    const handleDelete = useCallback(
        (row) => {
            confirmDialog({
                message: isAnnouncement(row) ? th('lmsNews.confirmDeleteMessage') : th('lmsNews.confirmDeleteTrainingMessage'),
                header: th('common.delete'),
                icon: 'pi pi-exclamation-triangle',
                acceptClassName: 'p-button-danger',
                accept: () => deleteNews(row.id)
            });
        },
        [deleteNews, th]
    );

    return (
        <div className="card">
            <ConfirmDialog />

            <div className="flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
                <h1 className="m-0">{th('lmsNews.managementTitle')}</h1>
                <div className="flex gap-2">
                    <Link to="/learning-management-system/news" className="p-button p-button-outlined no-underline gap-2">
                        <i className="pi pi-external-link" />
                        <span className="font-bold">{th('lmsNews.goToNewsPage')}</span>
                    </Link>
                    {can(LMS.NEWS_CREATE) && <Button label={th('lmsNews.newAnnouncement')} icon="pi pi-plus" onClick={() => openForm()} />}
                </div>
            </div>

            <LmsNewsTable
                items={items}
                totalCount={totalCount}
                loading={loading}
                lazyParams={lazyParams}
                onPage={onPage}
                sortField={sortField}
                sortOrder={sortOrder}
                onSort={onSort}
                filters={filters}
                onFilter={onFilter}
                onClearFilters={clearFilters}
                onEdit={handleEdit}
                onDelete={can(LMS.NEWS_DELETE) ? handleDelete : undefined}
            />

            <LmsNewsFormDialog visible={formVisible} newsId={editingId} onHide={() => setFormVisible(false)} onSaved={refetch} readOnly={!!editingId && !can(LMS.NEWS_UPDATE)} />
        </div>
    );
};

export default LmsNewsManagementPage;
